import { OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { useTheme } from "styled-components";
import { useQueryClient } from "@tanstack/react-query";

// import { Button } from "components/Button/";
import { userDetailSelect } from "Layout/slice/selector";
import {
  PROFILE_MENU_UPPER_V2,
  PROFILE_MENU_LOWER_V2,
  THEME_TYPES,
} from "utils/constants";
import { useNavigation } from "utils/navigate";
import { selectedIsUnsaved } from "features/Strategy/v2/ETFBuilder/slice/selector";
import { appClearStorage } from "utils/storage";
import { AccountDropdownPopover } from "../Navbar.styles";
import { clearUserState, setTheme, toast } from "Layout/slice/index";
import { updateIsLoggedIn } from "features/Auth/slice/thunk";
import { trackEvent } from "utils/tracking";
import { parseErrorMessage, trimmedName } from "utils/index";
// import { Switch } from "components/Switch";
import { iconDropdownArrow } from "assets/icons";
import { useState } from "react";

export const AccountDropdown = () => {
  // const themeColor = useTheme();
  const dispatch = useDispatch();
  const user = useSelector(userDetailSelect);
  const isUnsaved = useSelector(selectedIsUnsaved);
  const queryClient = useQueryClient();

  const [show, setShow] = useState(false);

  const {
    navigateToV2AccountOverview,
    navigateToV2Invite,
    navigateToV2Signin,
    // navigateToHostDashboard,
  } = useNavigation();

  // const currentTheme = themeColor.mode;

  const handleSignout = () => {
    try {
      navigateToV2Signin();

      if (isUnsaved) {
        return;
      }

      queryClient.clear();

      appClearStorage();
      dispatch(setTheme(THEME_TYPES.LIGHT));
      dispatch(clearUserState());
      dispatch(updateIsLoggedIn());
      trackEvent({ category: "signout", label: "Navbar" });
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const menuClickHandler = {
    settings: navigateToV2AccountOverview,
    signout: handleSignout,
    invite: navigateToV2Invite,
  };

  const handleMenuClick = (id) => {
    menuClickHandler[id]();
    document.body.click();
  };

  const handleToggle = (nextShow) => {
    setShow(nextShow);
  };

  // const handleThemeSwitch = () => {
  //   const newTheme =
  //     currentTheme === THEME_TYPES.DARK ? THEME_TYPES.LIGHT : THEME_TYPES.DARK;

  //   dispatch(setTheme(newTheme));
  // };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-end"
      rootClose
      popperConfig={{
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 10] },
          },
        ],
      }}
      onToggle={handleToggle}
      overlay={
        <AccountDropdownPopover>
          <Popover.Body>
            {/* {user?.is_creator && (
              <Button onClick={navigateToHostDashboard}>
                My Host Dashboard
              </Button>
            )} */}
            <ul>
              {PROFILE_MENU_UPPER_V2.map((menu) => (
                <li key={menu.id} onClick={() => handleMenuClick(menu.id)}>
                  {menu.icon} {menu.name}
                </li>
              ))}

              {/* <li className="justify-content-between">
                Dark mode{" "}
                <Switch
                  defaultValue={currentTheme === THEME_TYPES.DARK}
                  onChange={handleThemeSwitch}
                />
              </li> */}
            </ul>

            <div className="user-details">
              {user?.user_icon ? (
                <img src={user?.user_icon} />
              ) : (
                <div className="user-icon">
                  <span className="text-ellipsis">
                    {trimmedName(user?.first_name)}
                  </span>
                </div>
              )}
              <div>
                <div className="user-name">
                  {user?.first_name} {user?.last_name}
                </div>
                <div className="user-email text-ellipsis">{user?.email}</div>
              </div>
            </div>

            <div className="sign-out">
              {PROFILE_MENU_LOWER_V2.map((menu) => (
                <div
                  className="item"
                  key={menu.id}
                  onClick={() => handleMenuClick(menu.id)}
                >
                  {menu.icon} {menu.name}
                </div>
              ))}
            </div>
          </Popover.Body>
        </AccountDropdownPopover>
      }
    >
      <div className={`logged-in-wrap ${show ? "active" : ""}`}>
        <div className="logged-in-user-wrapper">
          <div className="logged-in-user">
            {user?.user_icon ? (
              <img src={user?.user_icon} />
            ) : (
              <div className="user-icon">
                <span className="text-ellipsis">
                  {trimmedName(user?.first_name)}
                </span>
              </div>
            )}
          </div>
          <span className="user-name-display">{user?.first_name}</span>
        </div>

        <img src={iconDropdownArrow} />
      </div>
    </OverlayTrigger>
  );
};
